export const dismissOnContextMenu = (onDismiss: () => void) => ({
  root: {
    onContextMenu: (event: React.MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onDismiss();
    }
  } as React.HTMLAttributes<HTMLDivElement>
});
